import React, { useState, useRef, useEffect } from "react";
import { FaCommentAlt, FaChevronUp, FaChevronDown } from "react-icons/fa";

const Cateringscrollingorder = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [expandedCard, setExpandedCard] = useState(null);
    const [isPaused, setIsPaused] = useState(false);
    const scrollRef = useRef(null);

    const toggleCard = (index) => {
        setExpandedCard(expandedCard === index ? null : index);
    };

    const handleAccept = (orderId) => {
        console.log("Accepted:", orderId);
    };

    const handleReject = (orderId) => {
        console.log("Rejected:", orderId);
    };

    // ===== Static Orders Data =====
    const orders = [
        {
            orderId: "ORD001",
            orderType: "ONLINE",
            service: "Booking",
            orderDateAndTime: "2025-09-20T11:15:00",
            order: [
                { dishName: "Dosa", quantity: 4 },
                { dishName: "Idly", quantity: 5 },
            ],
        },
        {
            orderId: "ORD002",
            orderType: "ONLINE",
            service: "Delivery",
            orderDateAndTime: "2025-09-20T12:30:00",
            order: [
                { dishName: "Vada", quantity: 3 },
                { dishName: "Uttapam", quantity: 2 },
            ],
        },
        {
            orderId: "ORD003",
            orderType: "TABLE_DINE_IN",
            service: "Dining",
            orderDateAndTime: "2025-09-20T13:00:00",
            order: [
                { dishName: "Pongal", quantity: 2 },
                { dishName: "Chapati", quantity: 4 },
            ],
        },
        {
            orderId: "ORD004",
            orderType: "TABLE_DINE_IN",
            service: "Dining",
            orderDateAndTime: "2025-09-20T13:00:00",
            order: [
                { dishName: "Pongal", quantity: 2 },
                { dishName: "Chapati", quantity: 4 },
            ],
        },
    ];

    // ===== Auto-scroll effect All the required forma=====
    useEffect(() => {
        const scrollContainer = scrollRef.current;
        if (!scrollContainer) return;

        let scrollInterval;
        if (!isPaused) {
            scrollInterval = setInterval(() => {
                if (scrollContainer.scrollTop + scrollContainer.clientHeight >= scrollContainer.scrollHeight) {
                    // Reset to top when reaching bottom
                    scrollContainer.scrollTop = 0;
                } else {
                    scrollContainer.scrollTop += 1; // scroll 1px every interval
                }
            }, 30); // speed: 30ms per step
        }

        return () => clearInterval(scrollInterval);
    }, [isPaused]);

    return (
        <div
            style={{
                position: "fixed",
                bottom: "62px",
                right: "16px",
                top: "40px",
                height: "560px",
                borderRadius: "8px",
                padding: "10px",
                marginTop: "40px",
            }}
            className="scroll-fixed-data mobilescroll"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
        >
            <div
                ref={scrollRef}
                style={{
                    maxHeight: "570px",
                    overflowY: "auto",
                    paddingRight: "5px",
                    scrollbarWidth: "none",
                    msOverflowStyle: "none",
                    marginTop: "28px",
                }}
                className="hide-scrollbar"
            >
                {orders.map((order, index) => (
                    <div
                        key={order.orderId}
                        onClick={() => toggleCard(index)}
                        className="card 
                     
                        "
                        style={{
                            width: "300px",
                            marginBottom: "12px",
                            background: "rgb(255, 99, 71)",
                            borderRadius: "10px",
                            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            padding: "15px",
                            color: "#fff",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "100%",
                                textAlign: "center",
                            }}
                        >
                            <h4 style={{ marginBottom: "10px" }}>Order ID: {order.orderId}</h4>
                            <p>Service: {order.service || order.orderType}</p>

                            <div
                                style={{
                                    display: "flex",
                                    gap: "10px",
                                    marginTop: "10px",
                                }}
                            >
                                <button
                                    onClick={() => handleAccept(order.orderId)}
                                    style={{
                                        flex: 1,
                                        backgroundColor: "rgb(160 85 176)",
                                        border: "none",
                                        color: "#fff",
                                        padding: "6px 12px",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                        fontWeight: "bold",
                                    }}
                                >
                                    Accept
                                </button>
                                <button
                                    onClick={() => handleReject(order.orderId)}
                                    style={{
                                        flex: 1,
                                        backgroundColor: "rgb(160 85 176)",
                                        border: "none",
                                        padding: "6px 12px",
                                        color: "#fff",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                        fontWeight: "bold",
                                    }}
                                >
                                    Reject
                                </button>
                            </div>

                            {expandedCard === index && (
                                <div
                                    style={{
                                        marginTop: "10px",
                                        backgroundColor: "rgba(255, 255, 255, 0.1)",
                                        padding: "10px",
                                        borderRadius: "8px",
                                        width: "100%",
                                    }}
                                >
                                    <p>
                                        <strong>Date:</strong>{" "}
                                        {new Date(order.orderDateAndTime).toLocaleDateString()}
                                    </p>
                                    <p>
                                        <strong>Time:</strong>{" "}
                                        {new Date(order.orderDateAndTime).toLocaleTimeString([], {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                        })}
                                    </p>
                                    <p>
                                        <strong>Items:</strong>{" "}
                                        {order.order
                                            .map((item) => `${item.dishName} x ${item.quantity}`)
                                            .join(", ")}
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            {/* Support Chat Box */}
            <div
                style={{
                    position: "fixed",
                    bottom: "0px",
                    right: "30px",
                    width: "303px",
                    backgroundColor: "#fff",
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                    borderRadius: "10px",
                    overflow: "hidden",
                    transition: "height 0.3s ease-in-out",
                    height: isOpen ? "400px" : "50px",
                    zIndex: 9999,
                }}
            >
                <div
                    style={{
                        backgroundColor: "#b15cd6",
                        color: "#fff",
                        padding: "10px",
                        fontWeight: "bold",
                        textAlign: "center",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        cursor: "pointer",
                    }}
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <FaCommentAlt style={{ marginLeft: "10px" }} />
                    <span style={{ flexGrow: 1, textAlign: "center" }}>Support</span>
                    {isOpen ? (
                        <FaChevronDown style={{ marginRight: "10px" }} />
                    ) : (
                        <FaChevronUp style={{ marginRight: "10px" }} />
                    )}
                </div>
                {isOpen && (
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            flex: 1,
                            overflowY: "auto",
                            padding: "10px",
                            height: "352px",
                            scrollbarWidth: "none",
                        }}
                    >
                        <h4 style={{ textAlign: "center", marginBottom: "10px" }}>Raise a Ticket</h4>
                        {/* Add your ticket form here */}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Cateringscrollingorder;
